
import HeroSection from './components/HeroSection';
import { Helmet } from "react-helmet-async";
import FeaturesSection from './components/FeaturesSection';
import VideoSection from './components/VideoSection';
import BenefitsSection from './components/BenefitsSection';
import StatsSection from './components/StatsSection';
import FAQSection from './components/FAQSection';
import { SavingsProvider } from './contexts/SavingsContext';
import Footer from './components/footer'
import Navigation from './components/Navigation'
import {PageName} from '../../configs/config'
import { trackPageView} from '../../utlis/useAnalytics'
import { useEffect } from "react";

function App() {
  useEffect(() => {
    trackPageView(PageName.PACBLanding);
  }, []);
  return (
    <SavingsProvider>
      <Helmet>
        <title>Start Your Global Business Journey with EximPe</title>
        <meta name="description" content="Discover how EximPe simplifies international trade and payments for Indian businesses. Try our platform or request a free demo today." />
        </Helmet>
      <div className="font-sans">
        <Navigation />
        <FeaturesSection />
        <HeroSection />
        <StatsSection />
        
        <VideoSection />
        <BenefitsSection />
        <FAQSection />
        <Footer />
       
      </div>
    </SavingsProvider>
  );
}

export default App;